import React, {Component} from 'react'
import 'react-multi-carousel/lib/styles.css'
import {withNamespaces} from 'react-i18next'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import Avatar from '@material-ui/core/Avatar'
import "../assets/handicap.scss"
import Handicap from '../pages/handicap'
import i18n from '../i18n'
import httpRequest from '../components/request-api'
import ScoreHistoryDetail from '../pages/score-history-detail'
import InfiniteScroll from "react-infinite-scroll-component"
import Typography from '@material-ui/core/Typography'
import Statistics from '../pages/statistics'
import {Tab, Tabs} from '@material-ui/core'
import Scorecards from '../components/scorecards'

const TabPanel = (props) => {
    const { children, value, index, ...other } = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`wrapped-tabpanel-${index}`}
            aria-labelledby={`wrapped-tab-${index}`}
            {...other}
        >
            {value === index && children}
        </div>
    )
}

class ExploreDetail extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            data: [],
            items: [],
            togglePage: true,
            scoreHis: {},
            hasMore: true,
            page: 1,
            profile: {},
            historyYear: [],
            tabIndex: 0,
        }
        this.changeLanguage(this.props.match.params.lang)
    }

    changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    }

    componentDidMount() {
        this.historyScore(this.props.match.params.id, this.state.page).finally(() => this.setState({
            loading: false
        }))
        window.scrollTo({top: 0, behavior: 'smooth'});
    }

    historyScore = async (memberCode, page) => {
        await httpRequest.historyScore(memberCode, page).then(result => {
            this.setState({
                items: this.state.items.concat(result.data.result.data),
                total: result.data.result.total,
                page: page,
                profile: result.data.result.profile,
            })

        }).catch(error => {
            console.log(error);
        })
    }

    fetchMoreData = () => {
        if (this.state.items.length >= this.state.total) {
            this.setState({hasMore: false});
            return;
        }
        setTimeout(() => {
            this.historyScore(this.props.match.params.id, this.state.page + 1)
        }, 1000);
    };

    render() {
        const handleClick = (items) => {
            this.setState({
                togglePage: !togglePage,
                scoreHis: items
            })
        };

        const setName = (item) => {
            if (this.props.lng === "th") {
                return `${item['name_th'] ? item['name_th'] : item['name_en']}`
            } else if (this.props.lng === "en") {
                return `${item['name_en'] ? item['name_en'] : item['name_th']}`
            }
        };

        const handleChange = (ev, index) => {
            this.setState({
                tabIndex: index
            })
        }

        const {t} = this.props;
        const {items, togglePage, scoreHis, profile} = this.state
        let handicap

        if (profile.hasOwnProperty('hcp'))
            handicap = profile['hcp'] === null ? 'N/A' : `${profile['hcp'] < 0 ? '+' : ''}${Math.abs(profile['hcp'])}`

        return (
            <div id="app">
                {!togglePage ? <ScoreHistoryDetail scoreHis={scoreHis} handleClick={handleClick.bind(this)}/> :
                    <main style={{"marginBottom": "7rem", height: "100vh"}}>
                        <div className="row profile-card">
                            <ListItem className="col-10">
                                <ListItemAvatar className="image-cropper"
                                                style={{...profile.avatar ? {width: '50px', height: '50px'} : {}}}>
                                    {!profile.avatar ? <Avatar/> :
                                        <img src={`data:image/png;base64,${profile.avatar}`} alt=""
                                             className="profile-pic"/>}
                                </ListItemAvatar>
                                {!profile.club ? <div/> :
                                    <ListItemText className="ml-3"
                                                  primary={
                                                      <React.Fragment>
                                                          <Typography className="member-display-name">ID: {this.props.match.params.id}</Typography>
                                                          <Typography className="member-display-name">{setName(profile)}</Typography>
                                                      </React.Fragment>
                                                  }
                                                  secondary={
                                                      profile.club[0] ? profile.club[0]['display_name'] : "-"
                                                  }/>
                                }
                            </ListItem>
                            <div className="pl-0 col-2 center">
                                <h4 className="color-white">{handicap}</h4>
                            </div>
                        </div>

                        <section className="services-area  services-padding p-3" style={{height: "100%"}}>
                            <div className="container container2">
                                <div className="project-heading">
                                    <Tabs value={this.state.tabIndex} onChange={handleChange}>
                                        <Tab label={t('handicapHistory')} />
                                        <Tab label={t('scoreHistory')} />
                                        <Tab label={t('playingStatistics')} />
                                    </Tabs>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-12 pl-0 pr-0">
                                        <TabPanel value={this.state.tabIndex} index={0}>
                                            <Handicap memberCode={this.props.match.params.id}/>
                                        </TabPanel>
                                        <TabPanel value={this.state.tabIndex} index={1}>
                                            <section>
                                                {!this.state.loading ? this.state.items.length === 0 ?
                                                    <div style={{height: "50vh"}}>
                                                        <div className="d-flex flex-column align-items-center justify-content-center" style={{height: "100%"}}>
                                                            <div>
                                                                <img src='/assets/img/handicap/no-score.svg' alt='no handicap score' />
                                                                <h6 className="mt-2" style={{color: "#929BA2"}}>{t('noScoreHistoryAlt')}</h6>
                                                            </div>
                                                        </div>
                                                    </div>
                                                     :
                                                    <InfiniteScroll
                                                        dataLength={this.state.items.length}
                                                        next={this.fetchMoreData}
                                                        hasMore={this.state.hasMore}
                                                        loader={<h6>{t('loading')}</h6>} style={{overflow: "inherit"}}>
                                                        {
                                                            items.map((item, i) => (
                                                                <Scorecards key={i} item={item} onClicked={handleClick}/>
                                                            ))
                                                        }
                                                    </InfiniteScroll>: <span>{t('loading')}</span>
                                                }
                                            </section>
                                        </TabPanel>
                                        <TabPanel value={this.state.tabIndex} index={2}>
                                            <Statistics />
                                        </TabPanel>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </main>
                }
            </div>

        );
    }
}

export default withNamespaces()(ExploreDetail);
